<template>
  <div class="h-full flex justify-center justify-items-center items-center ">
    <div class="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full text-gray-300" role="status">
      <span class="visually-hidden">
        Bestätige E-Mail...
      </span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

const props = defineProps({id: String, hash: String});
const router = useRouter();
const store = useStore();

const onSuccess = (result) => router.push({name: 'dashboard'});
const onFailure = (error) => router.push({name: 'verify'});

const mount = onMounted(() =>
{
  store.dispatch('auth/reload')
  .then(onSuccess)
  .catch(onFailure);
});
</script>
